import React, { Component } from "react";
import { Flex } from "../../styles/GlobalStyle.js";
import {
  ListTitle,
  ListHeaderTitle,
  ListSubTitle,
  StyledA,
  TopPadding,
  TitleLoading,
  BorderBottom,
  BoxLanguage,
} from "./Style";
import TopBar from "../../components/navbar/TopBar";
import Property from "../../model/property";
import { updateViFontStatus } from "../../utils/vietnameseFontHelper";
import LoadingIcon from "../../components/LoadingIcon";
import { withTranslation } from "react-i18next";
import ButtonLanguage from "../../components/ButtonLanguage";
import { get, isEmpty, isNull, sortBy } from "lodash";

import HeaderImage from "../../components/HeaderImage";
import placeholderRectangle from "../../assets/placeholder-rectangle.png";
import placeholderSquare from "../../assets/placeholder-square.png";

import Box from "@material-ui/core/Box";
import Skeleton from "@material-ui/lab/Skeleton";

const StoreListService = require("../../backend/StoreListService");
const ConfigurationsService = require("../../backend/ConfigurationsService");

async function parseStoreList(
  uid,
  expireKey,
  language,
  accessToken,
  pairGuest,
  signIn
) {
  const puid = Property.getUid();
  Property.setWebStoreType({
    uid: uid,
    k: expireKey,
    language: language,
    type: "store",
    accessToken: accessToken,
    pairGuest: pairGuest,
    signIn: signIn,
  });
  let response = await StoreListService.getStore(
    puid,
    uid,
    expireKey,
    language,
    true
  );
  return response.data;
}

class Categories extends Component {
  state = {
    navbarOpen: false,
    categories: [],
    logo: "",
    title: "",
    preset: {},
    configuration: {},
    loading: true,
  };

  componentDidMount = async () => {
    Property.setWebStoreHomePage(window.location.href);
    const query = new URLSearchParams(this.props.location.search);
    await this.callPresetList(query.get("puid"));
    await this.callConfiguration(query.get("puid"));
    await this.reload();
  };

  reload = async () => {
    const { i18n } = this.props;
    let query = new URLSearchParams(this.props.location.search);
    let propertyData = Property.getData();
    let store =
      !!propertyData && propertyData.store ? propertyData.store : null;
    const { backFrom } = this.props.location;
    if (backFrom && !isEmpty(store)) {
      this.setState({
        categories: store.categories,
        logo: store.image,
        title: store.title,
      });
      Property.clearPreviousTitle();
      Property.setPreviousTitle(store.title);
      return;
    }
    const platform = query.get("platform");
    const device_type = query.get("device_type");
    const accessToken = query.get("access_token");
    const mobileProperty = query.get("mobile_property");
    const expireKey = query.get("k");
    const pairGuest = query.get("pair_guest");
    const signIn = query.get("sign_in");
    const tableNo = query.get("table_no");

    if (
      expireKey !== Property.getExpireKey() ||
      accessToken !== Property.getAccessToken()
    ) {
      Property.clearCartItem();
    }
    Property.setUid(query.get("puid"));
    Property.setExpireKey(expireKey);
    Property.setAccessToken(accessToken);
    Property.setPairGuest(pairGuest);
    Property.setSignIn(signIn);
    Property.setPlatform(platform);
    Property.setMobileProperty(mobileProperty);
    Property.setDeviceType(device_type);
    Property.setTableNo(tableNo);
    await this.callParseStoreList(
      this.props.storeId,
      expireKey,
      i18n.language,
      accessToken,
      pairGuest,
      signIn
    );
  };

  callPresetList = async (puid) => {
    const response = await StoreListService.getPreset(puid);
    const presets = response.data;
    if (presets) {
      if (!isEmpty(presets.app_webstore_favicon_url)) {
        const favicon = document.getElementById("favicon");
        if (favicon) favicon.href = presets.app_webstore_favicon_url;
        const appleFavicon = document.getElementById("apple-favicon");
        if (appleFavicon) appleFavicon.href = presets.app_webstore_favicon_url;
      }
      const desktopContainer = document.getElementById("desktop-container");
      if (desktopContainer) {
        if (!isEmpty(presets.app_home_webapp_desktop_bg)) {
          desktopContainer.style.backgroundColor =
            presets.app_home_webapp_desktop_bg;
        }
      }
      const root = document.getElementById("root");
      const tabletContainer = document.getElementById("tablet-container");
      const wrapper = tabletContainer ? tabletContainer : root;
      if (wrapper) {
        if (!isEmpty(presets.app_home_global_background_color)) {
          wrapper.style.backgroundColor =
            presets.app_home_global_background_color;
        }
      }
    }
    await Property.setPreset(puid, presets);
    this.setState({ preset: presets });
  };

  callConfigurationApi = async (puid) => {
    try {
      const response = await ConfigurationsService.getConfiguration(puid);
      return response.data
    } catch (error) {
      return {}
    } 
  }
  
  callConfiguration = async (puid) => {
    let data =  await this.callConfigurationApi(puid);
    await Property.setConfiguration(puid, data);
    this.setState({ configuration: { ...Property.getConfiguration(puid) } });
  };

  callParseStoreList = (
    storeId,
    expireKey,
    language,
    accessToken,
    pairGuest,
    signIn
  ) => {
    // Fetch data from server to get the latest one
    parseStoreList(
      storeId,
      expireKey,
      language,
      accessToken,
      pairGuest,
      signIn
    ).then(
      function (result) {
        Property.setCurrencyCode(result.currency_code);
        Property.setData(result);
        updateViFontStatus(language);
        this.setState({
          categories: get(result, "store.categories", []),
          logo: get(result, "store.image", ""),
          title: get(result, "store.title", ""),
          loading: false,
        });

        // Set the navigation title for putting on next page title
        Property.clearPreviousTitle();
        Property.setPreviousTitle(get(result, "store.title", ""));
      }.bind(this)
    );
  };

  handleSeleted = () => {
    this.setState({
      categories: [],
      logo: "",
      title: "",
    });
    const webStoreType = Property.getWebStoreType();
    this.callParseStoreList(
      webStoreType.uid,
      webStoreType.k,
      this.props.i18n.language,
      webStoreType.accessToken,
      webStoreType.pairGuest,
      webStoreType.signIn
    );
  };

  render() {
    const { categories, title, preset } = this.state;
    const brandStyle = preset.app_brand_stylesheet;
    let windowWidth = window.innerWidth;
    let windowHeight = (window.innerHeight * 0.4).toFixed(0);
    if (windowWidth > 1280) {
      windowWidth = 1280;
    }
    if (brandStyle) {
      if (windowWidth <= 768) {
        windowHeight = 400;
      } else if (windowWidth > 768) {
        windowHeight = window.innerHeight;
      }
    }
    if (windowHeight > 400) {
      windowHeight = 400;
    }
    return (
      <div>
        {categories && categories.length === 0 ? (
          <div>
            <Skeleton
              variant="rect"
              height={Number(windowHeight)}
              animation={false}></Skeleton>
            {[0, 1, 2].map((value) => (
              <Box
                key={value}
                display="flex"
                p={1}>
                <Box
                  p={1}
                  flexShrink={0}>
                  <Skeleton
                    variant="rect"
                    width={120}
                    height={118}
                    animation={false}
                  />
                </Box>
                <Box
                  p={1}
                  width="100%">
                  <Skeleton
                    animation={false}
                    height={30}
                  />
                  <Skeleton
                    animation={false}
                    width="60%"
                    height={30}
                  />
                </Box>
              </Box>
            ))}
            <Flex flex={1}>
              <TitleLoading>
                <LoadingIcon loadingState={true} />
              </TitleLoading>
            </Flex>
            <BoxLanguage />
          </div>
        ) : (
          <>
            <TopBar
              title={this.state.title}
              previousUrl={"/store"}
            />
            <div className={"sectionContent"}>
              <TopPadding className="lg:hidden" />
              {this.state.logo ? (
                <div className={"sectionHeaderLandscape"}>
                  <HeaderImage
                    image={this.state.logo}
                    preset={preset}
                    placeholderRectangle={placeholderRectangle}
                    breakpointWidth={768}
                    breakpointHeight={400}
                  />
                </div>
              ) : null}
              <div className={"sectionContentLandscape"}>
                <Flex>
                  {sortBy(categories, ["position", "id"]).map((category) => {
                    return (
                      <StyledA
                        href={
                          category.kind === "url"
                            ? category.action_url
                            : `/categories/${category.uid}/products`
                        }
                        title={title}
                        key={category.uid}>
                        <Flex
                          container
                          alignItems={"center"}>
                          {category.image ? (
                            <HeaderImage
                              image={category.image}
                              preset={preset}
                              placeholderRectangle={placeholderSquare}
                              fixedWidth={120}
                              fixedHeight={120}
                            />
                          ) : null}
                          <Flex
                            flex={1}
                            margin={category.image ? "0 0 0 28px" : "0"}>
                            <ListTitle
                              className={"description"}
                              haveImage={category.image}>
                              <ListHeaderTitle
                                className={"itemListTextTitle"}
                                app_home_list_item_title_color={
                                  preset.app_home_list_item_title_color
                                }>
                                {isNull(category.title)
                                  ? ""
                                  : Property.getTitleCapital(
                                      category.title
                                    )}
                              </ListHeaderTitle>
                              {category.subtitle ? (
                                <ListSubTitle
                                  className={"itemListText"}
                                  category_img={category.image}
                                  app_home_list_item_subtitle_color={
                                    preset.app_home_list_item_subtitle_color
                                  }>
                                  {category.subtitle}
                                  {category.kind === "url" ? (
                                    <p>{category.action_url_text}</p>
                                  ) : null}
                                </ListSubTitle>
                              ) : null}
                            </ListTitle>
                          </Flex>
                        </Flex>
                        <BorderBottom haveImage={category.image} />
                      </StyledA>
                    );
                  })}
                </Flex>
              </div>
            </div>
          </>
        )}
        <ButtonLanguage
          onSelected={() => this.handleSeleted()}
          currentPage="store"
          showButton={isEmpty(categories) ? false : true}
        />
      </div>
    );
  }
}

export default withTranslation()(Categories);
